import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
let isLoginPopupShown = false;
import wixUsers from 'wix-users';
import { saveCleverTapEvent } from 'public/cleverTapEvents.js';
import wixData from 'wix-data';
import { orders } from 'wix-pricing-plans';
import { checkUserMemberShipPlans } from 'public/customAds.js';

let scrolledThroughReport = false;
let isPaidMember = false;
let ctQuizName = '';

const surveyOptionJSON = [
    { id: "1", value: "red", colour: "#E14942", icon: "https://static.wixstatic.com/shapes/de4f7d_eb657d4057f3489f9363a7f963e2d8cb.svg" },
    { id: "2", value: "yellow", colour: "#FFC130", icon: "https://static.wixstatic.com/shapes/de4f7d_6569555524a64e2488c8b24768b01c6f.svg" },
    { id: "3", value: "green", colour: "#69BB8D", icon: "https://static.wixstatic.com/shapes/de4f7d_165c781190f1444e8cc6bcda19752d37.svg" }
]

export function setSurveyHandler(data) { //expection data type [{key: string, value: string}]
    data.forEach(item => {
        setSurveyOptionClicks(item.key);
        setSelectedSurveyValue(item.key, item.value);
    })
}

function setSurveyOptionClicks(key) {

    //Add click observer survey's all 3 options
    $w(`#${key}Btn1, #${key}Btn2, #${key}Btn3`)?.onClick(btn => {
        const id = btn.target.id.slice(-1);
        const value = surveyOptionJSON.filter(item => { return item.id == id })[0].value;
        $w('#dynamicDataset').setFieldValue(key, value);
        $w("#dynamicDataset").save();
        setSelectedSurveyValue(key, value);

        if ($w(`#${key}MSG`).length != 0) {
            setTimeout(() => {
                $w(`#${key}MSG`).expand();
                setTimeout(() => {
                    $w(`#${key}MSG`).collapse();
                }, 5000);
            }, 1000);
        }
        if ($w("#referFriend").length != 0) {
            if (btn.target.id == `${key}Btn3`) {
                $w("#referFriend")?.expand();
            }
        }

    })
}

function setSelectedSurveyValue(key, value) {
    if (value) {
        //Step1:- reset UI of all options
        //$w(`#${key}Btn1, #${key}Btn2, #${key}Btn3`).style.backgroundColor = '#FFFFFF';
        //$w(`#${key}Btn1, #${key}Btn2, #${key}Btn3`).style.borderColor = '#CED4DA';

        $w(`#${key}Btn1`).style.backgroundColor = '#FFFFFF';
        $w(`#${key}Btn2`).style.backgroundColor = '#FFFFFF';
        $w(`#${key}Btn3`).style.backgroundColor = '#FFFFFF';

        $w(`#${key}Btn1`).style.borderColor = '#CED4DA';
        $w(`#${key}Btn2`).style.borderColor = '#CED4DA';
        $w(`#${key}Btn3`).style.borderColor = '#CED4DA';

        $w(`#${key}Btn1`).icon = 'https://static.wixstatic.com/shapes/de4f7d_cf87de8e133649a4acd3329888a5803e.svg';
        $w(`#${key}Btn2`).icon = 'https://static.wixstatic.com/shapes/de4f7d_19210b3070444f9aacdb53d2ff698a57.svg';
        $w(`#${key}Btn3`).icon = 'https://static.wixstatic.com/shapes/de4f7d_690e92827bc04e5c9d8609eae251a3e4.svg';

        //Step2:- set UI of selected option
        let item = surveyOptionJSON.filter(item => { return item.value.toLowerCase() == value.toLowerCase() })[0];
        const btnObject = $w(`#${key}Btn${item.id}`);
        btnObject.style.backgroundColor = item.colour;
        btnObject.style.borderColor = item.colour;
        btnObject.icon = item.icon;

    }
}

//----------------------******** PGS (Personalized Guidence Satisfaction) Survey Handler ----------------
$w('#personalizedProgressBar').value = 20;
const PGSSurveyOptionJSON = [
    { id: "1", value: "red", colour: "#E14942", icon: "https://static.wixstatic.com/shapes/de4f7d_ca9edd4b636a4e44975a13e2eaab96dd.svg" },
    { id: "2", value: "orange", colour: "#E18B25", icon: "https://static.wixstatic.com/shapes/de4f7d_54a5e3449e2144d7b2a0a9e8b6eb5716.svg" },
    { id: "3", value: "yellow", colour: "#FFC130", icon: "https://static.wixstatic.com/shapes/de4f7d_588758b4d7404c66b00e3b281c305479.svg" },
    { id: "4", value: "light green", colour: "#7EBB69", icon: "https://static.wixstatic.com/shapes/de4f7d_2c63c02393a6455dba0a9774af9bb6af.svg" },
    { id: "5", value: "green", colour: "#69BB8D", icon: "https://static.wixstatic.com/shapes/de4f7d_d3adb89416a04dedb6347b33879cbf56.svg" }
]

export function setPGSSurveyHandler(value, whatYouLikeAboutReport, howWeImproveReport) {

    //Step1:- Set value of selected PGSOption and PGSInput
    setSelectedPGSSurveyValue(value ?? '');
    $w('#whatYouLikeAboutReportInput').value = whatYouLikeAboutReport ?? '';
    $w('#howWeImproveReportInput').value = howWeImproveReport ?? '';
    if (!value) {
        $w('#howWeImproveReportContainer, #whatYouLikeAboutReportContainer, #PGSSubmitBtn').collapse();
    }

    if ($w('#howWeImproveReportInput').value != '' || $w('#whatYouLikeAboutReportInput').value != '') {
        $w('#personalizedProgressBar').value = 100;
    }

    //Step2:- Set value PGSOptions Click Event
    $w('#PGSBtn1, #PGSBtn2, #PGSBtn3, #PGSBtn4, #PGSBtn5')?.onClick(btn => {
        const id = btn.target.id.slice(-1);
        const value = PGSSurveyOptionJSON.filter(item => { return item.id == id })[0].value;
        $w('#dynamicDataset').setFieldValue("personalizedGuidanceSurvey", value)
        $w("#dynamicDataset").save();

        setSelectedPGSSurveyValue(value);
        if (value.toLowerCase() == "light green" || value.toLowerCase() == "green") {
            openShareQuizModel();
        }
        $w('#personalizedProgressBar').value = 50;
    });

    //Step3:- Set value PGSInput value change observer
    $w('#whatYouLikeAboutReportInput')?.onInput(event => {
        if ($w('#whatYouLikeAboutReportInput').value.trim() !== "") {
            $w("#PGSSubmitBtn").enable();
        } else {
            $w("#PGSSubmitBtn").disable();
        }
    });

    $w('#howWeImproveReportInput')?.onInput(event => {
        if ($w('#howWeImproveReportInput').value.trim() !== "") {
            $w("#PGSSubmitBtn").enable();
        } else {
            $w("#PGSSubmitBtn").disable();
        }
    });

    //Step4:- Set value PGSSubmitButton Click Event
    $w('#PGSSubmitBtn')?.onClick(btn => {
        $w("#dynamicDataset").setFieldValue("howWeImproveReport", $w('#howWeImproveReportInput').value);
        $w("#dynamicDataset").setFieldValue("whatYouLikeAboutReport", $w('#whatYouLikeAboutReportInput').value);
        $w("#dynamicDataset").save();
        $w('#personalizedProgressBar').value = 100;
        // setTimeout(function () {
        //     $w('#surveysucessmessage').expand();
        // }, 500);
        wixWindow.openLightbox("Share Quiz Thank you Feedback");
        reportSurveysCleverTapEvent();
    })
}

function setSelectedPGSSurveyValue(value) {
    //Step1:- Reset UI of all options
    $w('#PGSBtn1').style.backgroundColor = '#FFFFFF';
    $w('#PGSBtn2').style.backgroundColor = '#FFFFFF';
    $w('#PGSBtn3').style.backgroundColor = '#FFFFFF';
    $w('#PGSBtn4').style.backgroundColor = '#FFFFFF';
    $w('#PGSBtn5').style.backgroundColor = '#FFFFFF';

    $w('#PGSBtn1').style.borderColor = '#CED4DA';
    $w('#PGSBtn2').style.borderColor = '#CED4DA';
    $w('#PGSBtn3').style.borderColor = '#CED4DA';
    $w('#PGSBtn4').style.borderColor = '#CED4DA';
    $w('#PGSBtn5').style.borderColor = '#CED4DA';

    $w('#PGSBtn1').icon = 'https://static.wixstatic.com/shapes/de4f7d_7db84c6c0df046f289c84e104f80e829.svg';
    $w('#PGSBtn2').icon = 'https://static.wixstatic.com/shapes/de4f7d_28a35a0c06904447af81cc2c0b4f5756.svg';
    $w('#PGSBtn3').icon = 'https://static.wixstatic.com/shapes/de4f7d_c121cf42b860433f852ff4e52f87572c.svg';
    $w('#PGSBtn4').icon = 'https://static.wixstatic.com/shapes/de4f7d_c1d4a34cf9954c7a8445a20eb8ef88fb.svg';
    $w('#PGSBtn5').icon = 'https://static.wixstatic.com/shapes/de4f7d_619d078c624f453ba4aa7823b98afdbf.svg';

    //Step2:- Set UI of selected options
    let filteredItems = PGSSurveyOptionJSON.filter(item => { return item.value.toLowerCase() == value.toLowerCase() });
    if (filteredItems.length > 0) {
        let item = filteredItems[0];
        const btnObject = $w(`#PGSBtn${item.id}`);
        btnObject.style.backgroundColor = item.colour;
        btnObject.style.borderColor = item.colour;
        btnObject.icon = item.icon;
    }

    //Step3:- Set UI of Submit Button and Input Container
    if (value.toLowerCase() == "light green" || value.toLowerCase() == "green") {
        $w('#whatYouLikeAboutReportContainer, #PGSSubmitBtn').expand();
        $w('#howWeImproveReportContainer').collapse();
    } else {
        $w('#howWeImproveReportContainer, #PGSSubmitBtn').expand();
        $w('#whatYouLikeAboutReportContainer').collapse();
    }
}

function openShareQuizModel() {
    const dataToSend = {
        saveCTAction: saveCTAction
    };
    wixWindow.openLightbox("Share Quiz", dataToSend).then(data => {
        if (data && data.sharedOn) {
            if (data.sharedOn == 'copyLink') {
                openIntermediateShareModal(data.sharedOn, data.link ?? "")
            } else {
                saveSharedHistory(data.sharedOn);
            }
            //openIntermediateShareModal(data.sharedOn, data.link ?? "", data.quizName ?? "" )
            //manageSocialShare(data.sharedOn, data.link ?? '')
        }
    });
}

export function manageSocialShare(sharedOn, link) {
    if (sharedOn == "instagram") {
        openIntermediateShareModal(link)
    } else {
        saveSharedHistory(sharedOn)
    }
}

export function openIntermediateShareModal(sharedOn, link, quizName) {
    if (sharedOn == 'copyLink') {
        saveSharedHistory(sharedOn);
    }
    wixWindow.openLightbox('Go to Intermediate Sharing', { "sharedOn": sharedOn, "link": link, "quizName": quizName ?? "" })
        .then(data => {
            if (data && data.shared) {
                saveSharedHistory(sharedOn);
            }
        })
        .catch((err) => {});
}

export function saveSharedHistory(sharedOn) {
    let sharedOnArray = $w("#dynamicDataset").getCurrentItem().sharedOn;
    if (!sharedOnArray) {
        sharedOnArray = [sharedOn];
    } else if (!sharedOnArray.includes(sharedOn)) {
        sharedOnArray.push(sharedOn);
    }
    $w("#dynamicDataset").setFieldValue('sharedOn', sharedOnArray);
    $w("#dynamicDataset").save();
}

function saveCTAction(eventName, eventData) {
    saveCleverTapEvent(eventName, eventData);
}

export async function getQuizName() {

    let urlprefix = wixLocation.prefix;
    //console.log('urlprefix:-', urlprefix);
    switch (urlprefix) {
    case "new-learning-mindset-report":
        urlprefix = "learning-mindset-report";
        break;
    default:
        break;
    }

    return new Promise((resolve) => {
        wixData.query("assessments")
            .eq("reportingPath", urlprefix) //wixLocation.prefix
            .find()
            .then((results) => {
                if (results.items.length > 0) {
                    let dataItems = results.items[0];
                    ctQuizName = dataItems.title;
                    resolve(ctQuizName);
                }
            })
            .catch((err) => {
                resolve([]);
                console.log(err);
            });
    })
}

export async function readReportCleverTapEvent() {
    let referrer = wixWindow.referrer;
    if (ctQuizName == '') {
        ctQuizName = await getQuizName();
    }
    saveCleverTapEvent('Read Report', { "DomainIds": "", "CategoryIDs": "", "MarketingSourceAttribution": referrer, "QuizName": ctQuizName });
}

async function reportSurveysCleverTapEvent() {
    if (ctQuizName == '') {
        ctQuizName = await getQuizName();
    }
    saveCleverTapEvent('User completes survey on the report page', { "QuizName": ctQuizName });
}

export function showGuestSignUpModal() {
    $w("#showSignUpmodal").onViewportEnter((event) => {
        console.log('showSignUpmodal onViewportEnter ....');
        /*
        let query = wixLocation.query;
        if (!wixUsers.currentUser.loggedIn && !isLoginPopupShown && query.minimal !== "yes") {
            wixWindow.openLightbox("Guest Sign Up")
                .then((rData) => {
                    isLoginPopupShown = true;
                    if (rData.toOpen === "signUpForm") {
                        wixWindow.openLightbox('SIGN UP', {
                                value: "signup",
                            })
                            .then((receivedData) => {
                                if (receivedData.userEmail) {
                                    $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
                                }
                            })
                    }
                })
        }
        */
    });
}

/*$w("#showSignUpmodal").onViewportEnter((event) => {
    let query = wixLocation.query;
    if (!wixUsers.currentUser.loggedIn && !isLoginPopupShown && query.minimal !== "yes") {
        wixWindow.openLightbox("Guest Sign Up")
            .then((rData) => {
                isLoginPopupShown = true;
                if (rData.toOpen === "signUpForm") {
                    wixWindow.openLightbox('SIGN UP', {
                            value: "signup",
                        })
                        .then((receivedData) => {
                            if (receivedData.userEmail) {
                                $w("#hiddenSubscribeEmailInput").value = receivedData.userEmail;
                            }
                        })
                }
            })
    }
});*/

/** CleverTap Events Starts **/
export async function scrolledThroughReportCTEvent(quizName) {
    isPaidMember = await checkUserMemberShipPlans();
    console.log('isPaidMember:-', isPaidMember);
    if (!isPaidMember) {
        $w("#scrolledThroughReport").onViewportEnter((event) => {
            if (!scrolledThroughReport) {
                scrolledThroughReport = true;
                const clevertapJson = {
                    "QuizName": quizName
                };
                saveCleverTapEvent('Ads Scrolled through Report', clevertapJson);
                spentTimeOnReportCTEvent();
            }
        });
    }
}

async function spentTimeOnReportCTEvent() {
    if (wixLocation.query.minimal !== "yes") {
        wixWindow.openLightbox("Reports Interference Ads");
        setInterval(() => {
            wixWindow.openLightbox("Reports Interference Ads");
        }, 5 * 60 * 1000);
    } else {
        saveCleverTapEvent('Ads Spent time on Report', {});
        setInterval(() => {
            saveCleverTapEvent('Ads Spent time on Report', {});
        }, 5 * 60 * 1000);
    }
}

/*export function scrolledThroughReportCTEvent(quizName) {
    $w("#scrolledThroughReport").onViewportEnter((event) => {
        if (!scrolledThroughReport) {
            scrolledThroughReport = true;
            const clevertapJson = {
                "QuizName": quizName
            };
            saveCleverTapEvent('Scrolled through Report', clevertapJson);
            spentTimeOnReportCTEvent(quizName);
        }
    });
}

async function spentTimeOnReportCTEvent(quizName) {
    isPaidMember = await checkMemberShipPlans();
    setInterval(() => {
        const clevertapJson = {
            "QuizName": quizName
        };
        saveCleverTapEvent('Spent time on Report', clevertapJson);
        if(!isPaidMember){
            console.log('User is not paid member');
        } else {
            console.log('User is paid member');
        }
    }, 5 * 60 * 1000);
}

async function checkMemberShipPlans() {
    const isLoggedIn = authentication.loggedIn();
    let paidPlans = ['Regular Member', 'Supporting Member', 'Regular Coach Member', 'Sponsoring Coach Member', 'Regular ICF Coach Member', 'Sponsoring ICF Coach Member']
    if (isLoggedIn) {
        orders.listCurrentMemberOrders({ 'orderStatuses': ['ACTIVE'] })
            .then((ordersList) => {
                let allActivePlans = [];
                if (ordersList && ordersList.length > 0) {
                    ordersList.forEach((order) => {
                        if (order.planName != `Donation` && !order.cancellation) {
                            allActivePlans.push(order);
                        }
                    });
                }
                if (allActivePlans && allActivePlans.length != 0) {
                    allActivePlans.forEach((order) => {
                        if (paidPlans.includes(order.planName)) {
                            isPaidMember = true;
                        }
                    });
                }

            })
    }
    return false
}*/
/** CleverTap Events Starts **/